const LandingPage = () => {
  return (
    <div>
      <h1>ZEEFI...</h1>Landing page...
    </div>
  );
};

export { LandingPage };
